var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-29C9.242 3 3 9.242 3 16s6.242 13 13 13 13-6.242 13-13S22.758 3 16 3z",
    fill: "#3867B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.849 8.363h-1.697v6.788H8.364v1.698h6.788v6.788h1.697v-6.788h6.788V15.15H16.85V8.363z",
    fill: "#3867B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.449 7.763v6.788h6.788v2.897H17.45v6.789h-2.897v-6.788H7.764V14.55h6.788V7.763h2.897zm-2.297.6h1.697v6.788h6.788v1.698H16.85v6.788h-1.697v-6.788H8.364V15.15h6.788V8.363z",
    fill: "#3867B1"
  })));
}
export default SvgPlusBtn;